export default [
  {
    path: '/carElectricity',
    component: () => import('@/views/ota/carElectricity.vue'),
    name: 'carElectricity',
    meta: {
      title: '车辆上电',
      backgroundClass: 'bg-black',
    },
  },
  {
    path: '/carConnect',
    component: () => import('@/views/ota/carConnect.vue'),
    name: 'carConnect',
    meta: {
      title: '车辆连接网络说明',
      backgroundClass: 'bg-black',
    },
  },
  {
    path: '/rideStatus',
    component: () => import('@/views/ota/rideStatus.vue'),
    name: 'rideStatus',
    meta: {
      title: '骑行状态说明',
      backgroundClass: 'bg-black',
    },
  },
  {
    path: '/engineStatus',
    component: () => import('@/views/ota/engineStatus.vue'),
    name: 'engineStatus',
    meta: {
      title: '发动机状态说明',
      backgroundClass: 'bg-black',
    },
  },
  {
    path: '/gearStatus',
    component: () => import('@/views/ota/gearStatus.vue'),
    name: 'gearStatus',
    meta: {
      title: '档位状态',
      backgroundClass: 'bg-black',
    },
  },
  {
    path: '/batteryStatus',
    component: () => import('@/views/ota/batteryStatus.vue'),
    name: 'batteryStatus',
    meta: {
      title: '电池状态',
      backgroundClass: 'bg-black',
    },
  },
  {
    path: '/upgrade',
    component: () => import('@/views/ota/upgrade.vue'),
    name: 'upgrade',
    meta: {
      title: '升级助手',
      backgroundClass: 'bg-black',
    },
  },
  {
    path: '/uuidUpgrade',
    component: () => import('@/views/ota/uuidUpgrade.vue'),
    name: 'uuidUpgrade',
    meta: {
      auth: 0,
      title: '仪表升级',
      backgroundClass: 'bg-black',
    },
  },
  {
    path: '/uuidInstru',
    component: () => import('@/views/ota/uuidInstru.vue'),
    name: 'uuidInstru',
    meta: {
      title: '仪表升级',
      backgroundClass: 'bg-black',
    },
  },
];
